import { fixedUi } from '@/i18n/fixedUi';
import React from 'react';

/** 列表区统一加载遮罩（查询 / 翻页 / 同步后重载） */
export function SpoListLoadingOverlay({
  visible = false,
  label = fixedUi("正在加载…"),
}) {
  if (!visible) return null;
  return (
    <div className="tpo-list-loading" role="status" aria-live="polite" aria-busy="true">
      <div className="tpo-list-loading__card">
        <i className="tpo-list-loading__spinner" aria-hidden="true" />
        <strong>{label}</strong>
      </div>
    </div>
  );
}

/**
 * 筛选区卡片：无标题。
 * - syncProgress：可选，挂在查询字段上方（一般改由页面顶部 TemuSyncProgressSlot 承载）
 * - toolbar：渲染为查询卡与列表卡之间的独立条（TemuOpsListToolbar），上下间距一致
 */
export function ProductFilterCard({ children, toolbar = null, syncProgress = null }) {
  return (
    <>
      <section className="tpo-card tpo-card--filter">
        <div className="tpo-card__section tpo-card__section--filter">
          {syncProgress}
          {children}
        </div>
      </section>
      {toolbar || null}
    </>
  );
}

export function ProductListCard({
  children,
  tabs = null,
  batchBar = null,
  loading = false,
  loadingLabel = fixedUi("正在加载…"),
}) {
  return (
    <section className={`tpo-card tpo-card--list${loading ? ' is-loading' : ''}`}>
      {tabs}
      {batchBar}
      <div className="tpo-card__section tpo-card__section--list">
        <div className="tpo-card__list-body">
          {children}
          <SpoListLoadingOverlay visible={loading} label={loadingLabel} />
        </div>
      </div>
    </section>
  );
}
